import * as React from 'react';
import { focusOutlineOuter } from '@leagueplatform/genesis-core';
import { ConfigEntityDetail, EntityDetail } from '@web-config-app/core';
import { selectableRendererRegistry } from '../cell-renderers/renderer-registry';
import {
  EntityListTable,
  type RowContext,
} from '../entity-list-table/entity-list-table.component';
import type { SelectableEntityListTableProps } from '../../../types/components.types';

export const SelectableEntityListTable = ({
  entityData,
  parentEntityId,
  getItemName,
  getDomainEntityId,
  isLoading = false,
  domainEntity,
  selectionMode = 'single',
  selectionProps,
  bulkActions,
}: SelectableEntityListTableProps<ConfigEntityDetail | EntityDetail>) => {
  const {
    onSelectAllChange,
    getItemSelectionState,
    selectedEntities,
    onEntitySelected,
  } = selectionProps;

  const getRowContext = React.useCallback(
    (item: ConfigEntityDetail | EntityDetail): RowContext => {
      const isDisabled = item.id === parentEntityId;

      return {
        itemId: getDomainEntityId(item),
        disabled: isDisabled,
        selected: getItemSelectionState?.(item.id) ?? false,
        onSelect: () => onEntitySelected(item),
        rowCss: {
          '&:focus-within': focusOutlineOuter,
          borderRadius: '$small',
          backgroundColor: isDisabled ? '$inputBackgroundDisabled' : undefined,
        },
      };
    },
    [
      getDomainEntityId,
      parentEntityId,
      getItemSelectionState,
      onEntitySelected,
    ],
  );

  return (
    <EntityListTable
      entityData={entityData}
      isLoading={isLoading}
      domainEntity={domainEntity}
      getItemName={getItemName}
      selectionMode={selectionMode}
      selectionProps={{
        onSelectAllChange,
        selectedEntities,
      }}
      bulkActions={bulkActions}
      getRowContext={getRowContext}
      registry={selectableRendererRegistry}
    />
  );
};
